<app-editable-text-field
  #editField
  [items]="structures"
  [addItemFlg]="true"
></app-editable-text-field>
<button (click)="onOfficialPositionCreated()">登録</button>
